module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.4f55d76b.svg";